

export interface AuthInterface {
    nombre: string;
    tipo: number;
    id_usuario?: number;
    keepaliveInterval?:number | null;
}

function state(): AuthInterface {
    return {
        nombre: '',
        tipo: 0,
        id_usuario: 0,
        keepaliveInterval: null
    }
}

export default state;